import { API_URL } from '../../constants';
import { getRequest, postRequest } from '../../utils/requestService';
import { getDispatch } from '../../../spa/store';

// mirrors backend/src/orm/entities/AudioWord.ts
export type TWordReason = 'explained' | 'mistake' | 'useful';

export type TAudioWordItem = {
	word: string;
	lemma: string;
	meaning: string;
	quote?: string;
	timestamp?: number;
	reason: TWordReason;
};

export interface IRestAudioWordsData {
	words: TAudioWordItem[];
	canRegenerate: boolean;
	// asked with lang: the stored translation of this list; missing — translated via fetchNative
	native?: TAudioWordNativeItem[];
}

// band: frequency in the language, 1 basic .. 3 rare (computed by the backend)
export type TLemmaResult = { lemma: string; foreign: boolean; band: number };

// mirrors backend TAudioWordNativeItem: the words item at the same index in the viewer's native language
export type TAudioWordNativeItem = { wordNative: string; meaningNative: string };

export class WordsRest {

	private static AUDIO_WORDS_URL = API_URL + '/audio/words';
	private static LEMMAS_URL = API_URL + '/words/lemmas';

	// langCode: the viewer's native language, for the stored translation
	public static async fetch(audioId: number, langCode?: string): Promise<IRestAudioWordsData> {
		const dispatch = getDispatch();
		return await dispatch(getRequest(`${WordsRest.AUDIO_WORDS_URL}/${audioId}${langCode ? `?lang=${encodeURIComponent(langCode)}` : ''}`));
	}

	public static async generate(audioId: number): Promise<{ words: TAudioWordItem[] }> {
		const dispatch = getDispatch();
		return await dispatch(postRequest(`${WordsRest.AUDIO_WORDS_URL}/${audioId}/generate`, {}));
	}

	public static async fetchNative(audioId: number, langCode: string): Promise<{ items: TAudioWordNativeItem[]; words: TAudioWordItem[] }> {
		const dispatch = getDispatch();
		return await dispatch(getRequest(`${WordsRest.AUDIO_WORDS_URL}/${audioId}/native?lang=${encodeURIComponent(langCode)}`));
	}

	// Resolves each word's dictionary lemma (and whether it belongs to the language at all).
	public static async fetchLemmas(langCode: string, words: string[]): Promise<Record<string, TLemmaResult>> {
		const dispatch = getDispatch();
		const result = await dispatch(postRequest(WordsRest.LEMMAS_URL, { langCode, words }));
		return result?.lemmas || {};
	}

}
